import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	ITest,
	LabelPosition,
	SinNumberRHF,
} from "@websential/cosmic-v20";
import { FC, useEffect } from "react";

interface IEmployeeSINSetupFieldsPanel extends ITest {
	sinStatusItems: any;
	selectdSinStatus: number;
	formMethods: any;
}
export let provinceResponce: any = undefined;
export const EmployeeSINSetupFieldsPanel: FC<IEmployeeSINSetupFieldsPanel> = ({
	sinStatusItems,
	selectdSinStatus,
	formMethods,
}) => {

	useEffect(() => {
		// formMethods.setValue("sinStatus", selectdSinStatus);
	}, [selectdSinStatus]);
	return (
		<>
			<SinNumberRHF
				id="socialInsuranceNumber"
				label="Social Insurance Number (SIN)"
				// required={true}
				labelPosition={LabelPosition.Top}
				labelColumns={4}
				fieldColumns={8}
				testId="socialInsuranceNumber"
			/>
			<EnhancedDropDownRHFWithLabel
				label="SIN Status"
				selectName="sinStatus"
				testId={`sin-status`}
				labelPosition={LabelPosition.Top}
				items={sinStatusItems ?? []}
				selectedItem={selectdSinStatus}
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedTextAreaFieldRHF
				label="Follow up Notes"
				id="followUpNotes"
				testId={`Follow-up-Notes`}
				placeholder="Follow up Notes"
				labelPosition={LabelPosition.Top}
				labelColumns={4}
				fieldColumns={8}
			/>
		</>
	);
};
